import ACTIONS from 'state/constants';

export const trackLandingPageEvent =
  ({ eventAction, eventLabel, eventValue }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.TRACK_EVENT,
      eventCategory: `LandingPage ${window.location.pathname}`,
      eventAction,
      eventLabel,
      eventValue,
    });
  };
